import {computed} from "vue";

import {usePermission} from "@/hook/usePermission";
import {EnumPortalList} from "@/enum/portal";

/**
 * 系統 (portal) 切換與可見性
 *
 * 後台有三個 portal: 我的教會 (/admin)、牧養系統 (/shepherd)、榮耀堂首頁 (/glory)。
 * 前兩個所有教會都看得到, 榮耀堂首頁只有 org=4 (台北榮耀堂) 看得到。
 *
 * ## 為什麼這裡不判斷 org
 *
 * 直覺的寫法是 `user.church.organization === 4`, 但那條路是壞的:
 * /api/session 回的 `church.organization` 是機構的 **uuid 字串**, 不是 seq
 * (dao_session.xml `'organization', o.uuid`), 而 uuid 在 dev / prod 是不同的值,
 * 寫死就會在其中一個環境失效, 且不會有任何錯誤訊息 —— 只是選單安靜地不出現。
 *
 * 所以改成讓「權限資料自己帶 org」: 後端 dao_admin_user.xml 的三支權限查詢
 * 已把 portal=3 的權限群組限定給 organization.seq = 4, 於是
 * **「權限陣列裡有沒有 61」就等價於「是不是榮耀堂」**, 連 root 帳號在別的教會登入
 * 也拿不到 (那三支 SQL 的 root 分支同樣有這條件)。
 */
export const usePortal = () => {

    const {
        isHasRight
    } = usePermission()

    /**
     * 是否為榮耀堂機構 (org=4)
     *
     * 61 = 榮耀堂首頁的控制面板權限群組代號。
     */
    const isOrgGlory = computed(() => isHasRight.value(61))

    /**
     * 目前身分看得到的 portal 清單 (含目前所在的那一個)
     */
    const getPortalList = computed(() => EnumPortalList.filter(i =>
        i.right === null || isHasRight.value(i.right)
    ))

    return {
        isOrgGlory,
        getPortalList
    }

}
